const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

// POST to an SSE endpoint and feed events to handlers. Rejects with a readable message.
export async function streamAi(path, body, { onSession, onDelta } = {}) {
    const res = await fetch(`${BACKEND_URL}/api${path}`, {
        method: "POST",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(body),
    });
    if (!res.ok) {
        const data = await res.json().catch(() => ({}));
        throw new Error(typeof data.detail === "string" ? data.detail : "The AI assistant couldn't reply just now.");
    }
    const reader = res.body.getReader();
    const decoder = new TextDecoder();
    let buf = "";
    for (;;) {
        const { value, done } = await reader.read();
        if (done) break;
        buf += decoder.decode(value, { stream: true });
        const parts = buf.split("\n\n");
        buf = parts.pop();
        for (const p of parts) {
            if (!p.startsWith("data: ")) continue;
            const ev = JSON.parse(p.slice(6));
            if (ev.type === "session") onSession?.(ev.id);
            else if (ev.type === "delta") onDelta?.(ev.text);
            else if (ev.type === "error") throw new Error(ev.message);
        }
    }
}
